import {ProjectTemplate} from "@/pb/api/devplan/types/templates";

export type TemplateFilterType = 'project' | 'document'

export function filterTemplates(templates: ProjectTemplate[], filters: TemplateFilterType[] | undefined) {
  if (filters === undefined || filters.length === 0) {
    return templates
  }
  return templates.filter(t => {
    if (t.details?.plan?.hide) {
      return filters.includes('document')
    } else {
      return filters.includes('project')
    }
  })
}

export function getFilterForTemplate(template: ProjectTemplate): TemplateFilterType {
  return template.details?.plan?.hide ? 'document' : 'project'
}

export function orderTemplates(templates: ProjectTemplate[]) {
  return templates.toSorted((a, b) => `${a.details!.quickLaunchOrder}.${a.meta!.name}`
    .localeCompare(`${b.details!.quickLaunchOrder}.${b.meta!.name}`))
}